import { ExternalLink, Disc3, Radio, Sailboat } from "lucide-react";
import { BOOK } from "../data/book";
import { useLang } from "../i18n";
import Reveal from "../components/Reveal";
import Marquee from "../components/Marquee";

const OPERE = [
  { title: "Una vita da DJ", year: "2025", unpublished: false },
  { title: "Vento a Prua", year: "2025", unpublished: false },
  { title: "Pensieri e parole", year: "", unpublished: true },
];

const Author = () => {
  const { t } = useLang();
  const facts = [
    { icon: Disc3, label: t("fact_1") },
    { icon: Radio, label: t("fact_2") },
    { icon: Sailboat, label: t("fact_3") },
  ];

  return (
    <main className="pt-16" data-testid="author-page">
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-24 grid lg:grid-cols-[1fr_1.2fr] gap-14 items-start">
        <Reveal>
          <div className="relative rounded-xl overflow-hidden border border-white/10 max-w-md">
            <img src="/img/author.png" alt="Andrea Perocchi alla consolle" className="w-full object-cover aspect-square" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
            <p className="absolute bottom-4 left-5 font-mono2 text-[10px] tracking-[0.3em] uppercase text-ember">{t("author_role")}</p>
          </div>
          <div className="flex gap-3 mt-6 max-w-md">
            {facts.map((f, i) => (
              <div key={i} className="flex-1 rounded-xl border border-white/10 bg-card p-4 text-center" data-testid={`author-fact-${i}`}>
                <f.icon className="w-5 h-5 mx-auto text-ember mb-2" />
                <p className="font-mono2 text-[10px] tracking-[0.15em] uppercase text-mist leading-snug">{f.label}</p>
              </div>
            ))}
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="font-mono2 text-xs tracking-[0.35em] uppercase text-ember mb-5">{t("author_kicker")}</p>
          <h1 className="font-display font-extrabold uppercase text-4xl sm:text-6xl tracking-tight leading-none mb-3" data-testid="author-name">
            {BOOK.author}
          </h1>
          <p className="font-serif-it text-2xl text-gold mb-9">«{t("hero_sub")}»</p>
          <p className="text-mist leading-relaxed text-sm sm:text-base mb-5" data-testid="author-bio-1">{t("author_p1")}</p>
          <p className="text-mist leading-relaxed text-sm sm:text-base mb-10" data-testid="author-bio-2">{t("author_p2")}</p>

          <div className="mb-12" data-testid="author-works">
            <p className="font-mono2 text-xs tracking-[0.3em] uppercase text-ember mb-4">{t("author_opere")}</p>
            <div className="flex flex-wrap gap-3">
              {OPERE.map((o) => (
                <span key={o.title} className="rounded-full border border-white/15 px-4 py-2 text-sm text-mist">
                  <span className="font-serif-it text-white">{o.title}</span>
                  <span className="font-mono2 text-[10px] tracking-widest uppercase ml-2 text-mute">
                    {o.unpublished ? t("author_unpublished") : o.year}
                  </span>
                </span>
              ))}
            </div>
          </div>

          <div className="rounded-xl border border-ember/30 bg-ember/5 p-7" data-testid="buy-box">
            <p className="font-mono2 text-xs tracking-[0.3em] uppercase text-ember mb-2">{t("buy_title")}</p>
            <p className="font-display font-bold text-lg mb-6">{t("buy_note")}</p>
            <div className="flex flex-wrap gap-4">
              <a
                href="https://www.amazon.it/Una-vita-Dj-Andrea-Perocchi-ebook/dp/B0GHZ5FR89/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="buy-link-amazon"
                className="inline-flex items-center gap-2 rounded-full bg-ember px-6 py-3 text-xs font-semibold uppercase tracking-wider text-black hover:bg-gold transition-colors"
              >
                {t("buy_ebook")} <ExternalLink className="w-3.5 h-3.5" />
              </a>
              <a
                href="https://ilmiolibro.kataweb.it/libro/narrativa/714005/una-vita-da-dj/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="buy-link-ilmiolibro"
                className="inline-flex items-center gap-2 rounded-full border border-gold/50 px-6 py-3 text-xs font-semibold uppercase tracking-wider text-gold hover:bg-gold hover:text-black transition-colors"
              >
                {t("buy_paper")} <ExternalLink className="w-3.5 h-3.5" />
              </a>
              <a
                href="https://perocchi.it"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="buy-link-perocchi"
                className="inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-xs font-semibold uppercase tracking-wider hover:border-ember hover:text-ember transition-colors"
              >
                perocchi.it <ExternalLink className="w-3.5 h-3.5" />
              </a>
            </div>
          </div>
        </Reveal>
      </section>
      <Marquee text={t("marquee")} />
    </main>
  );
};

export default Author;
